<div class="helpers-upload-main">
    <label [hidden]="title == ''">{{title}}</label>
    <div>
        <core-files-upload 
            [multiple]="true"
            [removed]="removed" 
            (response)="upload($event)"
            (onUploading)="onUploading($event)" 
            [hiddenUploaded]="true"
        ></core-files-upload>

        <core-file-uploaded-list-item 
            *ngFor="let file of files"
            [remove]="true" 
            (onRemove)="remove(file)" 
            [file]="file"
        ></core-file-uploaded-list-item>
    </div>
</div>